module.exports = __webpack_public_path__ + "img/medal3.5108cef2.png";